import React, { useState } from 'react';
import { Tabs } from 'antd';
import DisplayFaq from '../Organism/DisplayFaq';
import DisplayHelpCategory from '../Organism/DisplayHelpCategory';
import DisplayHelpDetails from '../Organism/DisplayHelpDetails';

const Help: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

   return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="FAQ" key="1">
        <DisplayFaq />       
      </Tabs.TabPane>
      <Tabs.TabPane tab="Help Category" key="2">
        <DisplayHelpCategory />       
      </Tabs.TabPane>
      <Tabs.TabPane tab="Help Details" key="3">
        <DisplayHelpDetails />       
      </Tabs.TabPane>
    </Tabs>
  );
};

export default Help;